<template>
  <div class="body">
    <List :immediate-check=false v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
      <RecordList :List="List" />
    </List>
    <Empty description="暂无数据" v-if="List.length===0" />
  </div>
</template>
<style lang="less" scoped>
@import url('./index.less');
</style>
<script>
import { Popup, Tab, Tabs, Empty, List } from "vant";
import RecordList from "./List/index";
export default {
  name: "EntryRecord",
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    RecordList,
    Empty,
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      List: [],
      page: 1,
    };
  },
  methods: {
    getList() {
      this.$toast.loading("加载中...");
      this.$api.user.getRecords({ page: this.page }).then((res) => {
        this.loading = false;
        let { list, page } = res.data;
        if (page.currentPage == 1) {
          this.List = list;
        } else {
          this.List = this.List.concat(list);
        }
        if (page.currentPage >= page.pageCount) {
          this.finished = true;
        } else {
          this.page++;
        }
        this.$toast.clear();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
        this.getList();
    });
  },
};
</script>